import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {deepAssign} from '@aofl/object-utils';

const sdo = {
  namespace: sdoNs.CLASSROOM_GROUP_INFO,
  mutations: {
    init() {
      return {
        id: 0,
        name: '',
        externalId: '',
        parentId: 0,
        groupPath: '',
        students: [],
        teachers: [],
        is_third_party_connected: false,
        managed_by: null,
        dashboardGroups: []
      };
    },
    setData(subState, {id, name, external_id, parent_id, path, students = [], teachers = [], is_third_party_connected, managed_by, dashboard_groups}) { //eslint-disable-line
      return Object.assign({}, subState, {
        id,
        name,
        externalId: external_id,
        parentId: parent_id,
        groupPath: path,
        students,
        teachers,
        is_third_party_connected,
        managed_by,
        dashboardGroups: dashboard_groups || []
      });
    },
    addTeacher(subState, teacher) {
      return Object.assign({}, subState, {
        teachers: [
          ...subState.teachers,
          teacher
        ]
      });
    },
    removeTeacher(subState, index) {
      return Object.assign({}, subState, {
        teachers: [
          ...subState.teachers.slice(0, index),
          ...subState.teachers.slice(index + 1)
        ]
      });
    },
    removeTeachers(subState) {
      return Object.assign({}, subState, {
        teachers: []
      });
    },
    addStudent(subState, student) {
      return Object.assign({}, subState, {
        students: [
          ...subState.students,
          student
        ]
      });
    },
    removeStudent(subState, index) {
      return Object.assign({}, subState, {
        students: [
          ...subState.students.slice(0, index),
          ...subState.students.slice(index + 1)
        ]
      });
    },
    removeStudents(subState) {
      return Object.assign({}, subState, {
        students: []
      });
    }
  },
  decorators: [
    (nextState) => { // $selectedGroups
      const nextSubState = nextState[sdoNs.CLASSROOM_GROUP_INFO];
      const state = storeInstance.getState();
      const subState = state[sdoNs.CLASSROOM_GROUP_INFO];

      if (
        typeof nextSubState.$selectedGroups === 'undefined' ||
        nextSubState.groupPath !== subState.groupPath
      ) {
        const $selectedGroups = [];
        const groupPathParts = nextSubState.groupPath.split('.');
        const groupInfo = nextState[sdoNs.SESSION].group_info;
        let found = false;
        for (let i = 0; i < groupPathParts.length; i++) {
          const groupId = parseInt(groupPathParts[i], 10);
          if (found && groupId) {
            $selectedGroups.push(groupId);
          }
          if (groupId === parseInt(groupInfo.id, 10)) {
            found = true;
          }
        }

        nextState = deepAssign(nextState, sdoNs.CLASSROOM_GROUP_INFO, {
          $selectedGroups
        });
      }
      return nextState;
    },
    (nextState) => { // $teacherIds
      const state = storeInstance.getState();
      const subState = state[sdoNs.CLASSROOM_GROUP_INFO];
      const nextSubState = nextState[sdoNs.CLASSROOM_GROUP_INFO];

      if (typeof nextState.$teacherIds === 'undefined' ||
      nextSubState.teachers !== subState.teachers) {
        const $teacherIds = nextSubState.teachers.map((item) => parseInt(item.id, 10));
        nextState = deepAssign(nextState, sdoNs.CLASSROOM_GROUP_INFO, {$teacherIds});
      }

      return nextState;
    },
    (nextState) => { // $studentIds
      const state = storeInstance.getState();
      const subState = state[sdoNs.CLASSROOM_GROUP_INFO];
      const nextSubState = nextState[sdoNs.CLASSROOM_GROUP_INFO];

      if (typeof nextState.$studentIds === 'undefined' ||
      nextSubState.students !== subState.students) {
        const $studentIds = nextSubState.students.map((item) => parseInt(item.id, 10));

        nextState = deepAssign(nextState, sdoNs.CLASSROOM_GROUP_INFO, {$studentIds});
      }

      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
